exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__PanelCards__cards__2z8Rn {\n  height: calc(100% - 60px);\n  overflow-x: visible;\n}\n\n.dmb-web__PanelCards__container__3jpMC {\n  height: 100%;\n  overflow-y: scroll;\n}\n\n.dmb-web__PanelCards__cardsSplitCollapsed__3H_-G {\n  height: auto;\n  overflow-y: hidden;\n}\n\n.dmb-web__PanelCards__cardsSplitExpanded__10oy2 {\n  height: calc(100% - 50px);\n  overflow-y: auto;\n}\n", ""]);

// exports
exports.locals = {
	"cards": "dmb-web__PanelCards__cards__2z8Rn",
	"container": "dmb-web__PanelCards__container__3jpMC",
	"cardsSplitCollapsed": "dmb-web__PanelCards__cardsSplitCollapsed__3H_-G",
	"cardsSplitExpanded": "dmb-web__PanelCards__cardsSplitExpanded__10oy2"
};